import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { StatsSection } from './components/StatsSection';
import { FeaturesSection } from './components/FeaturesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { ClientDeckPage } from './components/ClientDeckPage';
import { DesignSystemPage } from './components/DesignSystemPage';
import { StyleGuidePage } from './components/StyleGuidePage';
import { BrandManualPage } from './components/BrandManualPage';
import { SimpleBrandManual } from './components/SimpleBrandManual';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="w-full min-h-screen bg-white" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<>
                <Header data-id="element-4" />
                <main className="pt-0" data-id="element-5">
                  <HeroSection data-id="element-6" />
                  <StatsSection data-id="element-7" />
                  <FeaturesSection data-id="element-8" />
                  <TestimonialsSection data-id="element-9" />
                  <PricingSection data-id="element-10" />
                </main>
              </>} data-id="element-3" />
          <Route path="/client-deck" element={<ClientDeckPage data-id="element-12" />} data-id="element-11" />
          <Route path="/design-system" element={<DesignSystemPage data-id="element-14" />} data-id="element-13" />
          <Route path="/style-guide" element={<StyleGuidePage data-id="element-16" />} data-id="element-15" />
          <Route path="/brand-manual" element={<SimpleBrandManual data-id="element-18" />} data-id="element-17" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-20" />} data-id="element-19" />
        </Routes>
      </div>
    </BrowserRouter>;
}